import type { IconifyIcon } from '@iconify/types'

export default {
  body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 17V3m-6 8l6 6l6-6m1 10H5"/>',
  width: 24,
  height: 24
} satisfies IconifyIcon
